import { render, staticRenderFns } from "./SoliLessonTypes.vue?vue&type=template&id=a152046c"
import script from "./SoliLessonTypes.vue?vue&type=script&lang=js"
export * from "./SoliLessonTypes.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports